module.exports = __webpack_public_path__ + "img/kt-zfk.b20c065c.png";